// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table-send-mail[data-v-08feb055] {\n  min-height: unset !important;\n  height: auto !important;\n}", ""]);
// Exports
module.exports = exports;
